export default __webpack_public_path__ + "static/media/thumbnail_6.0e527d82.webp";